module fdm.rawFiles {

    class FlightLegsInRawFileController {

        public link: dg.restfulApi.Link;
        public query: any;
        public queryManipulator: dg.actions.ServerQueryManipulator;

        public options = dg.lists.ListOptionsService.getGridOptions({
            type: 'grid',
            useExternalSorting: true,
            useGridScroll: false,
            uiGrid: {
                enableSorting: true,
                columnDefs: [
                    { field: 'aggregate', width: 125 },
                    { field: 'status', width: 85 },
                    { field: 'legDate', minWidth: 110 },
                    { field: 'legEndDate', minWidth: 110 },
                    { field: 'duration', minWidth: 72 },
                    { field: 'departure', minWidth: 80 },
                    //{ field: 'arrival', minWidth: 70 },
                    { field: 'flightNo', minWidth: 75 },
                    //{ field: 'criticalEvents', width: 65 },
                    //{ field: 'majorEvents', width: 65 },
                    //{ field: 'minorEvents', width: 65 },
                    { field: 'engineStatus', width: 110 }
                    ////{
                    ////    field: 'level',
                    ////    cellTemplate: '/app/src/flight-legs/flight-leg-level-grid-template-cell.html'
                    ////}
                ]
            },

        });

        // public queryManipulator = new dg.actions.ClientQueryManipulator(this.$scope, this.$q, <any>{});

        public constructor(
            public $scope: any,
            private $q: ng.IQService,
            private $element: ng.IAugmentedJQuery,
            protected actionService: dg.actions.ActionService) {
        }

        $onChanges(changes) {
            if (changes.link.currentValue) {
                this.getData();
            }
        }

        async getData() {
            this.query = await this.actionService.getActionFromLink(this.link);
            this.queryManipulator = new dg.actions.ServerQueryManipulator(this.$scope, this.$q, this.query, this.actionService);
            this.queryManipulator.executeQuery();
        }
    };

    angular.module('fdm.rawFiles').component('flightLegsInRawFile', {
        bindings: {
            link: '<',
        },
        controller: FlightLegsInRawFileController,
        templateUrl: '/app/src/raw-files/flight-legs-in-raw-file.html'
    });
}
